/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable shopify/jquery-dollar-sign-reference */
/* eslint-disable quote-props */
/**
 * Cart methods
 * -----------------------------------------------------------------------------
 *
 * @namespace cart
 */

import axios from 'axios';

// IE11 bug: we need to disable cache for this request
const axiosConfig = {
  headers: {
    'Cache-Control': 'must-revalidate',
    'Cache-Control': 'no-cache',
    'Cache-Control': 'no-store',
    Pragma: 'no-cache',
  },
};

const cartMethods = {
  data() {
    return {
      isCartAjaxed: false,
      loadingEvent: null,
      cart: {},
    };
  },

  methods: {
    _initCart() {
      const isCartAjaxed = $('[data-template="cart"]').data('cart-ajaxed');
      if (isCartAjaxed) {
        app.isCartAjaxed = true;
      }
      app._getCartData();
    },

    _mergeObjs(def, obj) {
      if (typeof obj === 'undefined') {
        return def;
      } else if (typeof def === 'undefined') {
        return obj;
      }
      for (const i in obj) {
        if (obj[i] != null && obj[i].constructor === Object) {
          def[i] = app._mergeObjs(def[i], obj[i]);
        } else {
          def[i] = obj[i];
        }
      }
      return def;
    },

    _getCartDefault() {
      return axios.get('/cart.js', axiosConfig);
    },

    _getCartExtra() {
      return axios.get('/cart?view=extra.json', axiosConfig);
    },

    /**
     * Get the cart data json object
     */
    _getCartData() {
      let Pro_ID = '';
      let v_title = '';
      Pro_ID = $('.service-product').data('product_id');

      app.pro_Available_flag = false;
      app.cart_item_id = [];

      axios.all([app._getCartDefault(), app._getCartExtra()])
        .then(axios.spread((basic, extra) => {
          // Both requests are now complete
          const basicCartData = basic.data;
          const mergedItems = app._mergeObjs(basic.data.items, extra.data.items);
          basicCartData.items = mergedItems;
          const item_ar = [];
          let item_type = {};
          let item_theme_count = 0;
          let item_other_count = 0;

          basicCartData.items.forEach((item) => {
            const obj = {};
            obj.id = item.product_id;
            obj.name = item.product_title;
            obj.sku = item.sku;
            obj.price = app._formatMoney(item.final_line_price).replace('$', '');
            obj.variant = item.variant_title;
            obj.quantity = item.quantity;
            obj.collections = item.collections;
            item_ar.push(obj);
            if (app.currentTemplate === 'cart') {
              dataLayer.push({
                'event': 'Cart View',
                'ecommerce': {
                  'cart': {
                    'products': item_ar,
                  },
                },
              });

            }

            if (item.product_options != null && Pro_ID !== 'undefined' && Pro_ID === item.product_id) {
              let item_pro;
              app.pro_Available_flag = true;
              for (let i = 0; i < item.product_options.length; i++) {
                if (item.product_options[i].name === 'Turnaround time') {
                  item_pro = item.product_options[i];
                }
              }

              if (item_pro) {
                v_title = item.variant_title;
              }
            }

            if (!item.properties) {
              item.properties = [];
            }

            if (item.product_type == 'theme') {
              item_theme_count++;
            } else {
              item_other_count++;
            }

            // eslint-disable-next-line quote-props
            app.cart_item_id.push({ 'product_id': item.product_id, 'variant_id': item.id, 'variant_title': item.variant_title, 'properties': item.properties });
          });

          item_type['item_theme_count'] = item_theme_count;
          item_type['item_other_count'] = item_other_count;
          app.cart_item_type_count = item_type;

          const $select_v_title = $('.service-product form[data-product-form] .size-swatch input');
          setTimeout(() => {
            if (app.pro_Available_flag) {
              $('.addtocart').attr('disabled', true);
              app.loadingEvent = 'cartAdded';
              $select_v_title.each(function () {
                if (v_title === $(this).attr('id')) {
                  $(this).prop('checked', true);
                  app._getVariant('');
                }
              });
            } else {
              $('.addtocart').attr('disabled', false);
              app.pro_Available_flag = false;
              app.loadingEvent = null;
              if (Pro_ID) {
                app._getVariant('');
              }
            }
          }, 1000);

          app.cart = basicCartData;
          app.loadCart = true;
        }));
    },

    /**
     * Event to add a variant to the cart
     * adds item properties from hidden fields automatically
     *
     * @param  {number} variantId - current variant id
     */
    _addToCart(variantId, event, arr) {
      const $form = $(event.currentTarget).closest(app.selectors.productForm);
      const $qtyEl = $form.find(app.selectors.qtyInput);
      const qtyValue = $qtyEl.val() || 1;
      const productCartLimit = $(event.currentTarget).attr('data-cart-limit') || null;
      const $event_target_product = $(event.currentTarget);

      if (variantId == null | variantId == '') {
        variantId = $event_target_product.siblings('input[name="id"]').val();
      }
      const cartProduct = app.cart.items.find((x) => x.variant_id === variantId);
      let cart_product;
      $(app.cart.items).each((index, item) => {
        if (variantId == item.variant_id && $event_target_product.closest('.service-product').length <= 0) {
          cart_product = item;
        }
      });

      if (cart_product) {
        app._toggleCartDrawer();
        return false;
      }

      let package_flag = true;
      let plan_section_target = $event_target_product.closest('.plan-section');
      if (plan_section_target.length > 0) {
        plan_section_target.find('[data-product-id]').each(function (index, item) {
          const data_pro_id = $(this).attr('data-product-id');
          package_flag = true;
          $(app.cart_item_id).each((i, product) => {
            console.log(product.product_id.toString(), data_pro_id);
            if (product.product_id.toString() == data_pro_id) {
              package_flag = false;
              return false;
            }
          });
          if (!package_flag) {
            return false;
          }
        });
        if (!package_flag) {
          $('#cart-message').modal('show');
          return false;
        }
      }
      let new_arry = [];
      const cart_ids = [];
      const arr_ids = [];
      const flag = true;
      $(app.cart.items).each((index, item) => {
        cart_ids.push(item.variant_id.toString());
      });
      if (arr) {
        for (let i = 0; i < arr.length; i++) {
          arr_ids.push(arr[i].variant_id);
        }
      }
      new_arry = arr_ids.filter((id) => {
        return !cart_ids.includes(id);
      });

      let new_arr_full = [];
      if (new_arry.length > 0) {
        new_arr_full = arr.filter((arr_ele) => {
          return new_arry.includes(arr_ele.variant_id);
        });
      }
      if (new_arr_full.length > 0) {
        arr = new_arr_full;
      } else if (arr_ids.length > 0) {
        arr = [];
        app._toggleCartDrawer();
        return false;
      }

      const totalQty = (cartProduct ? Number(qtyValue) + Number(cartProduct.quantity) : qtyValue);
      const properties = {};

      const productAddons = app.productAddons.products;
      Shopify.queue = [];

      if ($event_target_product.length > 0) {
        dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'currencyCode': app.cart.currency,
            'add': { // 'add' actionFieldObject measures.
              'products': [{ //  adding a product to a shopping cart.
                'name': $event_target_product.attr('data-product-title'),
                'id': $event_target_product.attr('data-product-id'),
                'price': $event_target_product.attr('data-product-price').replace('$', ''),
                'variant': $event_target_product.attr('data-product-variant'),
                'quantity': $event_target_product.attr('data-product-qty'),
              }],
            },
          },
        });
      }

      // add cart limit property
      if (productCartLimit) {
        properties.cart_limit = productCartLimit;
      }

      // check if item has product limit assigned
      if (app._productHasCartLimit(totalQty, productCartLimit)) {
        return;
      }

      app.isLoading = true;
      app.loadingEvent = 'cartAdding';

      let uid;
      if (app.pro_Available_flag && cartProduct !== undefined) {
        uid = cartProduct.properties.uid;
      } else if (cart_product !== undefined) {
        uid = cart_product.properties.uid;
      } else if (new_arr_full.length > 0) {
        if (app.cart.items.length > 0) {
          let uid_temp;
          $(app.cart.items).each((index, item) => {
            for (let i = 0; i < arr_ids.length; i++) {
              if (item.variant_id == arr_ids[i]) {
                uid_temp = item.properties.uid;
                return false;
              }
            }
          });
          if (uid_temp) {
            uid = uid_temp;
          } else {
            uid = Math.floor(Math.random() * Math.floor(1000));
          }
        } else {
          uid = Math.floor(Math.random() * Math.floor(1000));
        }
      } else {
        uid = Math.floor(Math.random() * Math.floor(1000));
      }

      properties.uid = uid;

      // Pass all properties to the cart line item
      $.each($event_target_product.siblings('input[name*="properties"]').serializeArray(), function () {
        const name = this.name.replace('properties[', '').replace(']', '');
        properties[name] = this.value;
      });

      // ReCharge Integration
      // if product is a subscription one use the reCharge Discount VariantId
      // Recharge code start
      if ('subscription_id' in properties) {
        properties.shipping_interval_frequency = $('[name="properties[shipping_interval_frequency]"]').val();
        if (app.reChargeDiscountVariantId) {
          variantId = app.reChargeDiscountVariantId;
        }
      }
      // Recharge code end

      if (arr !== '' && arr != null && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const addon_ = arr[i];
          if (addon_.properties !== undefined) {
            if (addon_.properties.uid == undefined) {
              addon_.properties.uid = uid;
            }
          } else {
            // eslint-disable-next-line quote-props
            addon_.properties = { 'uid': uid };
          }
          Shopify.queue.push({
            variantId: addon_.variant_id,
            prop: addon_.properties,
          });
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (!app.pro_Available_flag) {
          Shopify.queue.push({
            variantId,
            prop: properties,
          });
        }
      }

      // if there are selected product add-ons
      // push them also to the Shopify queue
      if (app.productAddons.selectedProduct.length > 0) {
        app.productAddons.selectedProduct.forEach((product) => {
          const pro_id = product.product_id;
          Shopify.queue.push({
            variantId: product.variant_id,
            prop: {
              // eslint-disable-next-line quote-props
              '_addon_product': 'true',
              // eslint-disable-next-line object-shorthand
              uid: uid,
            },
          });
        });
      }

      Shopify.moveAlong = function () {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          const request = Shopify.queue.shift();
          axios.post('/cart/add.js', {
            quantity: qtyValue,
            id: request.variantId,
            properties: request.prop,
          })
            .then((response) => {
              Shopify.moveAlong();
              return response.data;
            })
            .catch((error) => {
              if (Shopify.queue.length) {
                Shopify.moveAlong();
              }
              throw error;
            });
        } else {
          if (app.currentTemplate === 'cart' && !app.isCartAjaxed) {
            location.reload();
          }
          if ($event_target_product.length > 0) {
            adroll.track('addToCart', {
              siteType: 'm',
              currency: 'USD',
              products: [
                { id: $event_target_product.attr('data-product-id'), quantity: $event_target_product.attr('data-product-qty'), price: $event_target_product.attr('data-product-price').replace('$', '') },
              ],
            });
          }
          jQuery.getJSON('/cart.js', (cart) => {
            $('.cart-count .badge').text(cart.item_count);
          });
          app._getCartData();
          app._vibrateDevice();
          $qtyEl.val(1); // reset qty input to 1

          setTimeout(() => {
            app.isLoading = false;
            app.loadingEvent = 'cartAdded';
            app._toggleCartDrawer();
            app.loadingEvent = null;
          }, 500);
        }
      };
      Shopify.moveAlong();
    },

    /**
     * Event to remove a variant from the cart
     *
     * @param  {number} itemId - line item index
     */
    _removeFromCart(itemIndex, event) {
      const $cartItem = $(event.currentTarget).parentsUntil(app.selectors.cartItem).parent();
      const $event_target = $(event.currentTarget);

      dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
          'remove': { // 'remove' actionFieldObject measures.
            'products': [{ //  removing a product to a shopping cart.
              'name': $event_target.attr('data-product-title'),
              'id': $event_target.attr('data-product-id'),
              'sku': $event_target.attr('data-product-sku'),
              'price': app._formatMoney($event_target.attr('data-product-price')).replace('$', ''),
              'variant': $event_target.attr('data-product-variant'),
              'quantity': $event_target.attr('data-product-qty'),
            }],
          },
        },
      });

      app.isLoading = true;
      $cartItem.addClass('updating');

      const addon_arr = [];

      $(app.cart.items).each((index, item) => {
        $('[data-cart-item]').each(function (ind, product) {
          if (item.product_id == $(this).find('.remove').attr('data-product-id')) {
            addon_arr.push({ 'product_id': $(this).find('.remove').attr('data-product-id'), 'is_addon_pro': $(this).find('.remove').attr('data-is-addon') });
          }
        });
      });
      // eslint-disable-next-line prefer-const
      let arr = [];
      const uid_item = $event_target.attr('data-uid');
      const is_addon = $event_target.attr('data-is-addon');

      $(app.cart.items).each((index, item) => {
        if (item.properties != undefined && item.properties.uid != undefined) {

          const Random_no = item.properties.uid.toString();

          if (Random_no == uid_item) {
            let addon_pro;
            addon_arr.forEach((addon) => {
              if (addon.product_id == item.product_id) {
                addon_pro = addon;
              }
            });

            if (is_addon != undefined && is_addon) {
              if (addon_pro.is_addon_pro != undefined && addon_pro.is_addon_pro && $event_target.attr('data-product-id') == item.product_id) {
                arr.push(0);
              } else {
                const qty = item.quantity;
                arr.push(qty);
              }
            } else {
              arr.push(0);
            }
          } else {
            const qty = item.quantity;
            arr.push(qty);
          }
        } else {
          if (itemIndex == index + 1) {
            arr.push(0);
          } else {
            arr.push(item.quantity);
          }

        }
      });
      const params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: arr },
        dataType: 'json',
        async: false,
        success(response) {
          app.isLoading = false;
          app.__updatePixelCartAttr();
          app._getCartData();
          jQuery.getJSON('/cart.js', (cart) => {
            $('.cart-count .badge').text(cart.item_count);
          });
          $('[data-toggle="tooltip"]').tooltip('hide');
          return response;
        },
        error(er) {
          const err = $.parseJSON(er.responseText);
          return false;
        },
      };
      $.ajax(params);
    },

    /**
     * Event to update a variant in the cart
     *
     * @param  {number} itemIndex - line item index
     */
    _updateCart(itemIndex, event) {
      const $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
      const $cartItem = $(event.currentTarget).closest(app.selectors.cartItem);
      const productCartLimit = $cartItem.data('cart-limit') || null;
      let qtyValue = $qtyEl.val();

      if ($(event.currentTarget).data('qty-decrease') !== undefined) {
        if (parseFloat(qtyValue) >= 2) {
          qtyValue = parseFloat(qtyValue) - 1;
        }
      } else if ($(event.currentTarget).data('qty-increase') !== undefined) {
        qtyValue = parseFloat(qtyValue) + 1;

        // check if item has product limit assigned
        if (app._productHasCartLimit(qtyValue, productCartLimit)) {
          return;
        }
      }

      app.isLoading = true;
      $cartItem.addClass('updating');

      $($qtyEl).parent().css({
        'pointer-events': 'none',
      });

      axios.post('/cart/change.js', {
        quantity: qtyValue,
        line: itemIndex,
      })
        .then((response) => {
          app._getCartData();
          app.isLoading = false;
          $cartItem.removeClass('updating');
          $($qtyEl).parent().css({
            'pointer-events': 'inherit',
          });
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },

    _productHasCartLimit(qtyValue, productCartLimit) {
      if (productCartLimit) {
        if (qtyValue > productCartLimit) {
          console.log(`Product cart limit applies for the specific product variant. You can't purchase more than ${productCartLimit} item(s) per order.`);
          return true;
        }
      }
      return false;
    },

    /**
     * Vibrate mobile device
     */
    _vibrateDevice() {
      // check for vibration support
      const vibrationEnabled = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
      if (vibrationEnabled) {
        navigator.vibrate(100);
      }
    },

  },
};

export default cartMethods;

